import { convertValueToLocale } from "helpers/convertValueToLocale";

export const getInfoPopoverTitle = (t: any, info: any) => {
  if (info.parking?.length > 1) {
    return t(
      "calculator_pro_page.total_income_chart.info_popover_title_apartments_and_parkings",
      {
        downtimePercentage: convertValueToLocale(
          info.aptDowntimeLossPercent,
          2,
          "%"
        ),
      }
    );
  }

  if (info.parking?.length === 1) {
    return t(
      "calculator_pro_page.total_income_chart.info_popover_title_apartments_and_parking",
      {
        downtimePercentage: convertValueToLocale(
          info.aptDowntimeLossPercent,
          2,
          "%"
        ),
      }
    );
  }

  return t(
    "calculator_pro_page.total_income_chart.info_popover_title_apartments",
    {
      downtimePercentage: convertValueToLocale(info.aptDowntimeLossPercent, 2, "%"),
    }
  );
};

export const getEvenlySpacedYears = (
  totalIncomeChart: any,
  activePosition: 10 | 20 | 30,
  count: number
) => {
  const years = totalIncomeChart.totalRentalIncomeAndExpensesBrutto
    .filter((item: any) => item.yearIndex <= activePosition)
    .map((item: any) => item.year);

  if (years.length <= count) return years; // если элементов мало — вернуть как есть

  const result = [];
  const step = (years.length - 1) / (count - 1);

  for (let i = 0; i < count; i++) {
    const index = Math.round(i * step);
    result.push(years[index]);
  }

  return Array.from(new Set(result)); // убрать возможные дубликаты при округлении
};

export const getChartData = (totalIncomeChart: any, activePosition: 10 | 20 | 30) => {
  return totalIncomeChart.totalRentalIncomeAndExpensesBrutto
    .filter((item: any) => item.yearIndex <= activePosition)
    .map((item: any) => ({
      x: item.year,
      y: item.bruttoValue,
    }));
};

